import {
    DraftIcon,
    FileSearchIcon,
    FilesQuestionIcon,
    FileUserIcon,
    OcrIcon,
    ReadyForPaymentIcon,
} from '@approvalmax/ui';
import { selectors } from 'modules/common';
import { RequestListFilter } from 'pages/requestList/config';
import { useMemo } from 'react';
import bemFactory from 'react-bem-factory';
import { useGetIsWorkflowPayer } from 'shared/data/webApp/v2';
import { isOcrEnableForCompanyV2 } from 'shared/helpers';
import { getPath, Path } from 'urlBuilder';

import { useCompanies } from '../../Drawer.hooks';
import { messages } from './AllCompaniesMenu.messages';

const qa = bemFactory.qa('drawer-header-links');

export const useAllCompaniesLinksItems = () => {
    const companies = useCompanies();
    const showMyReviewRequiredLink = useMemo(
        () => companies.some(selectors.company.getIsReviewStepAvailableV2),
        [companies]
    );

    const showMyOcrRequests = useMemo(() => companies.some((company) => isOcrEnableForCompanyV2(company)), [companies]);
    const { data } = useGetIsWorkflowPayer();

    return useMemo(
        () => [
            {
                id: RequestListFilter.MyDecisionRequired,
                to: getPath(Path.requestMyList, RequestListFilter.MyDecisionRequired),
                dataQa: qa(),
                dataQaName: 'requiresMyDecision',
                title: messages.myDecisionRequiredLinkTitle,
                name: messages.myDecisionRequiredLinkName,
                startIcon: FilesQuestionIcon,
            },
            ...(showMyReviewRequiredLink
                ? [
                      {
                          id: RequestListFilter.MyReviewRequired,
                          to: getPath(Path.requestMyList, RequestListFilter.MyReviewRequired),
                          dataQa: qa(),
                          dataQaName: 'myReviewsRequired',
                          title: messages.myReviewRequiredLinkTitle,
                          name: messages.myReviewRequiredLinkName,
                          startIcon: FileSearchIcon,
                      },
                  ]
                : []),
            ...(showMyOcrRequests
                ? [
                      {
                          id: RequestListFilter.MyOcrRequests,
                          to: getPath(Path.requestMyList, RequestListFilter.MyOcrRequests),
                          dataQa: qa(),
                          dataQaName: 'capturedByMe',
                          title: messages.myOcrRequestsLinkTitle,
                          name: messages.myOcrRequestsLinkName,
                          startIcon: OcrIcon,
                      },
                  ]
                : []),
            {
                id: RequestListFilter.MyOnlyOpen,
                to: getPath(Path.requestMyList, RequestListFilter.MyOnlyOpen),
                dataQa: qa(),
                dataQaName: 'createdByMe',
                title: messages.myOpenLinkTitle,
                name: messages.myOpenLinkName,
                startIcon: FileUserIcon,
            },
            ...(data?.isWorkflowPayer
                ? [
                      {
                          id: RequestListFilter.MyReadyToPay,
                          to: getPath(Path.requestMyList, RequestListFilter.MyReadyToPay),
                          dataQa: qa(),
                          dataQaName: 'readyToPay',
                          title: messages.myReadyToPayTitle,
                          name: messages.myReadyToPayName,
                          startIcon: ReadyForPaymentIcon,
                      },
                  ]
                : []),
            {
                id: RequestListFilter.MyDraft,
                to: getPath(Path.requestMyList, RequestListFilter.MyDraft),
                dataQa: qa(),
                dataQaName: 'drafts',
                title: messages.myDraftLinkTitle,
                name: messages.myDraftLinkName,
                startIcon: DraftIcon,
            },
        ],
        [showMyReviewRequiredLink, showMyOcrRequests, data?.isWorkflowPayer]
    );
};
